import React, { useCallback, useState, useEffect} from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

import "./Quotes.css";

const SingleQuote = ({singleQuote, singleQuoteKeywords}) => {
  let { quoteid } = useParams();

  const [quote, setQuote] = useState([]);
  const [keywords, setKeywords] = useState([]);

  const fetchQuote = useCallback( () => {
    try {
      const response = axios.get(
        `${process.env.REACT_APP_STOIC_QUOTES}/${quoteid}`
      );
      setQuote(response.data[0]);
      setKeywords(response.data[0]["keywords"])
    } catch (error) {
      return error;
    }
  }, [quoteid]);

  useEffect(() => {
    if (quoteid) {
      fetchQuote()
    } else {
      setQuote(singleQuote);
      setKeywords(singleQuoteKeywords);
    }
  }, [fetchQuote, quoteid, singleQuote, singleQuoteKeywords]);
  
  return (
    <div className={`${quoteid ? `mt-6 md:mt-16` : null } bg-white mb-8 max-w-7xl mx-auto max-w-sm rounded overflow-hidden shadow-md hover:shadow-2xl transition duration-500 ease-in-out`}>
      <div className="bg-purple-500 h-2 w-full rounded-t-lg"></div>
      <div className="stylistic-quote-mark text-gray-200 z-0 ml-1 md:ml-3 -mt-6 absolute" aria-hidden="true">
        &ldquo;
      </div>
      <div className="p-4 sm:px-2 md:px-8">
        <div className="relative z-10 max-w-3xl mx-auto text-center text-xl md:text-2xl font-medium text-gray-900">
        <p>{quote.body}</p>
        </div>
        <footer className="mt-4">
          <div className="flex items-center justify-center">
            <Link to={`/philosophers/${quote.author}`} className="w-14 h-14 mr-3 overflow-hidden rounded-full">
              {quote.author === 'Marcus Aurelius' ? 
              ( 
                <img alt="Marcus Aurelius"
                src="https://upload.wikimedia.org/wikipedia/commons/c/c5/Marcus_Aurelius_Metropolitan_Museum.png" />
              )
              :
              (quote.author === 'Seneca' ? 
              ( 
                <img alt="Seneca"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/0_S%C3%A9n%C3%A8que_-_Mus%C3%A9e_du_Prado_-_Cat._144_-_%282%29.JPG/1024px-0_S%C3%A9n%C3%A8que_-_Mus%C3%A9e_du_Prado_-_Cat._144_-_%282%29.JPG" />
              ) 
              : 
              ( 
                <img alt="Epictetus"
                src="https://upload.wikimedia.org/wikipedia/commons/9/90/Epictetus.jpg" />
              ))}
            </Link>
            <div className="text-center md:mt-0 md:ml-2 md:flex md:items-center">
              <Link
                to={`/philosophers/${quote.author}`}
                className="text-xl italic font-bold leading-6 font-medium hover:underline text-gray-900"
                >
                {quote.author}
              </Link>
              <svg
                className="hidden md:block mx-1 h-5 w-5 text-indigo-600"
                fill="currentColor"
                viewBox="0 0 20 20"
                >
                  <path d="M11 0h3L9 20H6l5-20z" />
              </svg>
              <div className="text-lg italic leading-6 font-medium text-gray-500">
                {quote.quotesource}
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 mt-4 text-center text-lg">
          {keywords?.map((keyword, index) => (
            <Link
              to={`/topics/${keyword}`}
              key={index}
              className="mt-4 px-6 inline-block m-1 text-sm py-2 px-3 bg-gray-200 rounded-full hover:bg-gray-300 text-gray-800 text-black"
            >
              <div className="font-normal leading-none flex-initial ">
                {keyword}
              </div>
            </Link>
          ))}
        </div>
      </footer>
    </div>
  </div>
  )
  
};

export default SingleQuote;
